"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverBody", {
    enumerable: true,
    get: function() {
        return TeachingPopoverBody;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverBody = require("./useTeachingPopoverBody");
const _renderTeachingPopoverBody = require("./renderTeachingPopoverBody");
const _useTeachingPopoverBodyStylesstyles = require("./useTeachingPopoverBodyStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TeachingPopoverBody = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverBody.useTeachingPopoverBody_unstable)(props, ref);
    (0, _useTeachingPopoverBodyStylesstyles.useTeachingPopoverBodyStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverBodyStyles_unstable')(state);
    return (0, _renderTeachingPopoverBody.renderTeachingPopoverBody_unstable)(state);
});
TeachingPopoverBody.displayName = 'TeachingPopoverBody';
